import actionTypes from './actionTypes';

const initialState = {
  relatedCommunities: [],
};

const formatRelatedCommunities = rawRelatedCommunities => {
  const relatedCommunities = [];

  rawRelatedCommunities.forEach(rawRelatedCommunity => {
    const source = rawRelatedCommunity._source;
    const relatedCommunity = {
      fullLogoUrl: source.imageUrl,
      description: source.formattedDescription,
      followerCount: source.memberCount,
      name: source.formattedName,
      slug: source.subDomain,
    };
    relatedCommunities.push(relatedCommunity);
  });

  return relatedCommunities;
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_RELATED_COMMUNITIES_SUCCESS:
      const relatedCommunities = action.rawRelatedCommunities ? formatRelatedCommunities(action.rawRelatedCommunities) : action.relatedCommunities;
      return {
        ...state,
        relatedCommunities,
      };
  }
  return state;
};
